import PasswordInputField from './PasswordInputField';

export default PasswordInputField;
